import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import { AppForm } from "../forms/AppForm";
import { AppInput } from "../forms/AppInput";
import { AppSelect } from "../forms/AppSelect";
import { AppSubmit } from "../forms/AppSubmit";
import { RoutesNames } from "../components/utils/routes";
import { useToastInfo } from "../Hooks/useToastInfo";
import { validationModalYounger } from "../components/validations/validationModalYounger";
import { Variables } from "../styles/Variables";
import ModalTermsConditions from "./ModalTermAndConditions/ModalTermsConditions";

import {
  Modal,
  ContentAdult,
  ContainerInputAdult,
  ContainerInputsAdult,
  ContainerContent,
  TextPrincipal,
  TextContent,
  TextRequired,
  TextUrl,
  ButtonClose,
} from "./ModalTermAndConditions/styles";

const ModalAuthYounger = ({ modalVisible, setModalVisible, documentTypes, setDataAdult }) => {
  const router = useNavigate();
  /* eslint-disable */
  const ADULT_SUPERVISION_TERMS = process.env.REACT_APP_ADULT_SUPERVISION_TERMS;
  /* eslint-enable */
  const showToastInfo = useToastInfo();
  const [state, setState] = useState(null);
  const [terms, setTerms] = useState(null);
  const [modalTerms, setModalTerms] = useState(false);
  const [data, setData] = useState({});

  const handleAccept = () => {
    if (terms) {
      setModalVisible(false);
    }
    setModalTerms(false);
    setDataAdult({ ...data, terms, documentT: state });
  };

  const onFormCompleted = (values) => {
    setData(values);
    if (state === null) {
      return showToastInfo("Debe seleccionar un tipo de documento.");
    }
    setModalTerms(true);
  };

  return modalVisible ? (
    <Modal>
      <ContentAdult onClick={(event) => event.stopPropagation()}>
        <ButtonClose
          onClick={() => {
            setModalVisible(false);
            router(RoutesNames.home);
          }}
        >
          X
        </ButtonClose>
        <TextPrincipal>Autorización Inscripción menor de edad</TextPrincipal>
        <ContainerContent>
          <AppForm
            initialValues={{
              name: "",
              lastNames: "",
              documentT: "",
              documentNumber: "",
              numberPhone: "",
            }}
            onSubmit={onFormCompleted}
            validationSchema={validationModalYounger}
          >
            <TextContent>Información del Representante Legal del menor.</TextContent>
            <ContainerInputsAdult>
              <ContainerInputAdult>
                <AppInput
                  label="Nombre*"
                  name="name"
                  placeholder="Nombre"
                  style={{
                    height: "30px",
                  }}
                />
              </ContainerInputAdult>
              <ContainerInputAdult>
                <AppInput
                  label="Apellidos*"
                  name="lastNames"
                  placeholder="Apellidos"
                  style={{
                    height: "30px",
                  }}
                />
              </ContainerInputAdult>
            </ContainerInputsAdult>
            <ContainerInputsAdult>
              <ContainerInputAdult>
                <AppSelect
                  label="Tipo de documento(*)"
                  name="documentT"
                  data={documentTypes}
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  style={{
                    height: "30px",
                  }}
                />
              </ContainerInputAdult>
              <ContainerInputAdult style={{ height: "78px" }}>
                <AppInput
                  label="Número de documento(*)"
                  name="documentNumber"
                  style={{
                    height: "30px",
                  }}
                />
              </ContainerInputAdult>
            </ContainerInputsAdult>
            <ContainerInputsAdult>
              <ContainerInputAdult>
                <AppInput
                  label="Número de teléfono"
                  name="numberPhone"
                  style={{
                    height: "30px",
                  }}
                />
              </ContainerInputAdult>
            </ContainerInputsAdult>
            <TextRequired>(*)Los datos del menor deben ser ingresados en el próximo formulario</TextRequired>
            <AppSubmit title="Acepto" style={{ width: "40%", alignSelf: "center" }} />
          </AppForm>
        </ContainerContent>
        <TextUrl href="#">
          <h style={{ color: Variables.colorOrangeSecondary }}>www.integracion</h>
          <h style={{ color: Variables.colorBlueLight }}>migrante</h>
          <h style={{ color: Variables.colorRed }}>.com</h>
        </TextUrl>
      </ContentAdult>
      <ModalTermsConditions
        modalVisible={modalTerms}
        setModalVisible={setModalTerms}
        press={handleAccept}
        setTerms={setTerms}
        idTermsAndConditions={ADULT_SUPERVISION_TERMS}
      />
    </Modal>
  ) : (
    <div />
  );
};

ModalAuthYounger.propTypes = {
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
  documentTypes: PropTypes.array,
  setDataAdult: PropTypes.func,
};

export default ModalAuthYounger;
